import SignIn from '../features/sign_in/SignIn';

function PageSignIn(): JSX.Element {
	return <SignIn />;
}
export default PageSignIn;
